export default __webpack_public_path__ + "static/media/Watchful Eyes.4df8ccf8.png";